<apm-section-title title="{{ 444964 | apmTranslate }}">
  <apm-icon
    absoluteEndIcon
    icon="a_pdf_settings"
    size="md"
    [hasHoverIcon]="true"
    [isButton]="true"
    (iconClick)="openDatasheetSettings()"
  ></apm-icon>
</apm-section-title>

<div class="preview-container">
  @if (store.pdfLoading()) {
    <div class="preview-overlay">
      <apm-inline-spinner />
    </div>
  }

  @if (store.pdfError()) {
    <div class="preview-error">
      <apm-fa-icon icon="triangle-exclamation" iconSize="xl"></apm-fa-icon>
      <p>{{ 451854 | apmTranslate}}</p>
    </div>
  }

  @if (sanitizedPdfUrl(); as url) {
    <iframe class="pdf-iframe" [src]="url" frameborder="0"></iframe>
  }
</div>
